import { PARA_SCORE_RUBRIC, ParaScoreRubricItem } from '../models/para-score-rubric.const';

export type ParaScoreValue = 1 | 2 | 3 | 4;

export function coerceParaScore(value: unknown): ParaScoreValue | null {
	const n = typeof value === 'number' ? value : parseInt(String(value ?? ''), 10);
	if (!Number.isFinite(n)) return null;
	if (n === 1 || n === 2 || n === 3 || n === 4) return n;
	return null;
}

export function paraRubricItem(score: unknown): ParaScoreRubricItem | null {
	const n = coerceParaScore(score);
	if (!n) return null;
	return PARA_SCORE_RUBRIC.find((i) => i.score === n) ?? null;
}

export function paraScoreFillHex(score: unknown): string | null {
	return paraRubricItem(score)?.color ?? null;
}

export function paraScoreTintHex(score: unknown, alphaHex: string = '1A'): string | null {
	const hex = paraScoreFillHex(score);
	return hex ? `${hex}${alphaHex}` : null;
}

export function paraScoreTextHex(score: unknown): string {
	switch (coerceParaScore(score)) {
		case 4:
			return '#2D5E43'; // Mastery
		case 3:
			return '#2D435E'; // Proficient
		case 2:
			return '#7D5722'; // Progressing
		case 1:
			return '#8B3A38'; // Beginning
		default:
			return 'inherit';
	}
}

/** Mastery green — used for passing scores (3–4) in the progress table only. */
const PARA_PROGRESS_TABLE_PASS_GREEN = '#4A9B6F';
const PARA_PROGRESS_TABLE_PASS_GREEN_TEXT = '#2D5E43';

/** Progress table: faint green cell background for scores 3–4; none for 1–2. */
export function paraProgressTableScoreFaintHex(score: unknown, alphaHex: string = '1A'): string | null {
	const n = coerceParaScore(score);
	if (n === 3 || n === 4) {
		return `${PARA_PROGRESS_TABLE_PASS_GREEN}${alphaHex}`;
	}
	return null;
}

/** Progress table: green score text for 3–4; default for 1–2. */
export function paraProgressTableScoreTextHex(score: unknown): string {
	const n = coerceParaScore(score);
	if (n === 3 || n === 4) {
		return PARA_PROGRESS_TABLE_PASS_GREEN_TEXT;
	}
	return 'inherit';
}

/** Progress table: green chip for 3–4; no extra styling for 1–2. */
export function paraProgressTableScoreChipClass(score: unknown): string {
	const n = coerceParaScore(score);
	if (n === 3 || n === 4) {
		return 'tw-bg-[#4A9B6F] tw-text-white';
	}
	return '';
}

/**
 * Tailwind-friendly background class used by the progress table for score chips.
 * (Uses existing hard-coded colors to avoid relying on Tailwind runtime arbitrary values.)
 */
export function paraScoreChipClass(score: unknown): string {
	switch (coerceParaScore(score)) {
		case 4:
			return 'tw-bg-[#4A9B6F] tw-text-white';
		case 3:
			return 'tw-bg-[#5B8DB8] tw-text-white';
		case 2:
			return 'tw-bg-[#D4943A] tw-text-white';
		case 1:
			return 'tw-bg-[#DC6B68] tw-text-white';
		default:
			return 'tw-bg-slate-100 tw-text-para-primary tw-border tw-border-slate-200';
	}
}
